export class BasicAction{
    public ActionID:number = -1;
    public ActionAuthor:string = "";
    public ActionDescription:string = "";
    public AssignedTo:string = "";
    public Resolved:boolean;
    public ResolvedDate:Date;
    public ResolvedBy:string = "";
    public ActionDeadline:Date;
    public ActionTypeID:number = -1;
    public AuditResultDetailID:number = -1;
    public AuditName?: string;
    public ActionVariationID?: number;
    public AuditID?: number;
    public AuditResultID?: number;
    constructor(values: Object = {}){
        Object.assign(this, values);  
        if (values.hasOwnProperty('ActionDeadline') && this.ActionDeadline){
            this.ActionDeadline = new Date(this.ActionDeadline);
        }
        if (values.hasOwnProperty('ResolvedDate') && this.ResolvedDate){
            this.ResolvedDate = new Date(this.ResolvedDate);
        }   
    }
}
